export default {
  required: "Required",
};
